import React from 'react';
import AnimatedPage from './ui/AnimatedPage';
import PageSectionHeader from './ui/PageSectionHeader';
import ProfileCard from './ProfileCard';

const PROFILE_CONFIG = [
  {
    key: 'cepeda',
    tone: 'blue',
    accent: 'text-slate-800',
    border: 'border-slate-200',
    badge: 'bg-indigo-50 text-indigo-700'
  },
  {
    key: 'deLaEspriella',
    tone: 'red',
    accent: 'text-slate-800',
    border: 'border-slate-200',
    badge: 'bg-slate-100 text-slate-700'
  }
];

export default function Candidatos({ perfilesCandidatos = {} }) {
  return (
    <AnimatedPage as="section" className="max-w-7xl mx-auto px-4 py-10 md:px-6">
      <PageSectionHeader
        className="mb-10"
        eyebrow="Perfiles en contraste"
        title="Candidatos"
        description="Comparación visual y narrativa de los perfiles presidenciales para entender sus trayectorias, valores y estilos de liderazgo."
      />

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        {PROFILE_CONFIG.map(({ key, tone, accent, border, badge }) => (
          <ProfileCard
            key={key}
            perfil={perfilesCandidatos?.[key]}
            tone={tone}
            accent={accent}
            border={border}
            badge={badge}
          />
        ))}
      </div>
    </AnimatedPage>
  );
}
